
const state = () => ({
  token: '',
  name: '',
  profile_pic: '',
  organization_id: '',
  rol_id: '',
  rol: '',
  organization: '',
  widgets: ['TotalElementos','PorcentajesSentimientos','Tiempo']
})
const mutations = {
  SET_USER_DATA (state, userData) {
    state.token = userData.token
    state.name = userData.name
    state.profile_pic = userData.profile_pic
    state.organization_id = userData.organization_id
    state.rol_id = userData.rol_id
    state.rol = userData.rol
    state.organization = userData.organization
  },
  UNSET_USER_DATA (state) {
    state.token = ''
    state.name = ''
    state.profile_pic = ''
    state.organization_id = ''
    state.rol_id = ''
    state.rol = ''
    state.organization = ''
  },
  DELETE_WIDGET(state, widget) {
    if (state.widgets.indexOf(widget) > -1) {
      state.widgets.splice(state.widgets.indexOf(widget),1)
    }
  },
  SET_WIDGETS(state, widgets) {
    state.widgets=widgets
  },

}
const actions = {
  setUser({ commit }, data){
    commit('SET_USER_DATA', data)
  },
  unsetUser({commit}){
    commit('UNSET_USER_DATA')
  },
  removeWidget({ commit }, widget){
    commit('DELETE_WIDGET', widget)
  },
  setWidgets({ commit }, widgets){
    commit('SET_WIDGETS', widgets)
  },
}

const getters = {
  authentication: state => {
    return state.token
  },
  org: state => {
    return state.organization_id
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
